import { useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'

export function RawPage() {
  const { shareId } = useParams<{ shareId: string }>()
  const location = useLocation()
  const [content, setContent] = useState<string>('Loading...')

  useEffect(() => {
    const fetchRaw = async () => {
      if (!shareId) {
        setContent('404: Not Found')
        return
      }

      // Get passcode from hash fragment
      const passcode = location.hash ? location.hash.slice(1) : null

      const headers: Record<string, string> = {}
      if (passcode) {
        headers['X-Myrkup-Passcode'] = passcode
      }

      try {
        const res = await fetch(`/api/raw/${shareId}`, { headers })
        const text = await res.text()
        setContent(text)
      } catch {
        setContent('Failed to load content')
      }
    }

    fetchRaw()
  }, [shareId, location.hash])

  return (
    <pre
      style={{
        margin: 0,
        padding: '8px',
        fontFamily: 'monospace',
        fontSize: '12px',
        lineHeight: 1.4,
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
      }}
    >
      {content}
    </pre>
  )
}
